<template>
  <div>
    <b-modal
      ref="product-qty-box"
      title="Product Weight"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-footer
      size="sm"
      @hidden="updateProductModalBoxClose"
    >
      <b-form>
        <b-form-row>
          <b-col md="12 pb-3">
            <label class="fs-11">Product</label>
            <br />
            <span
              class="fs-12"
              v-text="data.name ? data.name : data.item_name"
            />
          </b-col>
          <b-col md="6">
            <label class="fs-11">Category</label>
            <br />
            <span class="fs-12" v-text="data.category" />
          </b-col>
          <b-col md="6">
            <b-row>
              <b-col md="12">
                <label
                  class="float-right fs-11"
                  v-text="`Unit ${data.uom} Price`"
                />
              </b-col>
              <br />
              <b-col md="12">
                <span class="float-right fs-12"
                  >{{ currencySymbol }}
                  {{
                    data.change_mrp
                      ? data.change_mrp
                      : data.mrp
                      ? data.mrp
                      : data.unit_mrp
                  }}</span
                >
              </b-col>
            </b-row>
          </b-col>
        </b-form-row>
        <br />
        <b-form-row>
          <b-col>
            <b-input-group
              :append="
                state.weightPort == '' || inputEnabled == true ? data.uom : ''
              "
            >
              <template v-slot:append>
                <div
                  class="d-flex align-items-center justify-content-center"
                  v-if="state.system.weightPort != ''"
                >
                  <!-- <font-awesome-icon
                    :icon="['fa', 'pencil-alt']"
                    style="cursor: pointer; font-size: 13px;"
                  />-->
                  <font-awesome-icon
                    :icon="['fa', 'minus-circle']"
                    v-if="inputEnabled == false"
                    @click="disableInput"
                    style="font-size: 13px; cursor: pointer; color: #ff6666"
                  />
                </div>
              </template>
              <b-form-input
                v-model="qtyValue"
                placeholder="Enter Weight"
                @keyup="clearErrMessage($event)"
                v-prodmaxqty
                id="qtyInput"
                type="number"
                autofocus
                autocomplete="off"
                v-negative-disable
                :disabled="
                  inputEnabled
                    ? state.system.weightPort != ''
                      ? true
                      : false
                    : false || $loading
                "
              />
            </b-input-group>
            <p
              :class="QtyErrMessage ? 'text-danger' : 'text-transparent'"
              class="mt-1 mb-0"
            >
              <font-awesome-icon :icon="['fas', 'exclamation-circle']" />
              <span
                :class="QtyErrMessage ? 'text-danger' : 'text-transparent'"
                v-text="
                  ` Quantity should be less than ${state.system.settings.cart.product_max_qty} kg`
                "
              />
            </p>
          </b-col>
        </b-form-row>
        <div class="d-flex mt-3">
          <b-button
            class="mr-1"
            v-if="state.system.weightPort != ''"
            @click="enableInput"
            :disabled="inputEnabled == false"
            >Edit</b-button
          >
          <b-button
            variant="primary"
            block
            type="submit"
            class=""
            :disabled="
              parseFloat(qtyValue).toFixed(2) <= 0 ||
                $loading ||
                qtyValue == '.' ||
                QtyErrMessage ||
                checkEmpty(qtyValue)
            "
            @click="addToCart"
          >
            <div v-if="!$loading">Add to Cart</div>
            <b-spinner small v-else />
          </b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
import qz from "../printer";
export default {
  name: "update-qty-modal",
  props: {
    open: false,
    data: "",
    pluQty: "",
    toCart: false,
  },
  data() {
    return {
      qtyValue: "",
      changeData: customData,
      inputEnabled: true,
      QtyErrMessage: false,
    };
  },
  computed: {
    ...mapState({
      state: (state) => state,
    }),
  },
  watch: {
    open() {
      if (this.open && !this.state.system.plu_data.status) {
        let self = this;
        this.$refs["product-qty-box"].show();
        console.log("[Product Qty Box] : Open");
        let delims = {
          start: "",
          end: "",
          width: null,
        };
        qz.serial.openPort(this.state.system.weightPort, delims);
        qz.serial.setSerialCallbacks((evt) => {
          let index = 0;
          if (evt.type !== "ERROR") {
            if (evt.output > 0.0) {
              if (
                !isNaN(evt.output) &&
                evt.output.toString().indexOf(".") != -1
              ) {
                let splitVal = evt.output.split(".");
                // console.log(splitVal[1].trim());
                if (splitVal[1].trim().length == 3) {
                  console.log("Cool : -" + splitVal[1].trim());
                  // self.qtyValue = evt.output;
                  if (splitVal[0].trim() != "") {
                    if (self.qtyValue != evt.output) {
                      self.qtyValue = evt.output;
                    } else {
                      if (self.qtyValue != "") {
                        self.qtyValue = evt.output;
                      }
                    }
                  }
                }
              }
              // if (self.qtyValue == evt.output) {
              // } else {
              //   self.qtyValue = evt.output;
              // }
            }
            // console.log("Serial", evt.portName, "received output", evt.output);
          } else {
            console.error(evt.exception);
          }
        });
      } else if (this.open && this.state.system.plu_data.status) {
        this.$refs["product-qty-box"].show();
        console.log("[Product Qty Box] : Open");
      } else {
        this.$refs["product-qty-box"].hide();
        console.log("[Product Qty Box] : Close");
      }
    },
    changeData: {
      handler(val) {
        // let self = this;
        console.log("In Data");
        if (val.data.status == "weight_value") {
          this.qtyValue = val.data.type;
        } else {
          console.log("Printer Not Working");
        }
      },
      deep: true,
    },
    data: {
      handler(val) {
        if (val.qty == "0") {
          val.qty = "";
        }
        // if (this.toCart)
        this.qtyValue = this.state.system.plu_data.status
          ? this.pluQty
          : val.qty;
      },
      deep: true,
    },
  },
  mounted() {
    // qz.serial.setSerialCallbacks(function(evt) {
    //   if (evt.type !== "ERROR") {
    //     self.readData = evt.output;
    //     console.log("Serial", evt.portName, "received output", evt.output);
    //   } else {
    //     console.error(evt.exception);
    //   }
    // });
  },
  methods: {
    addToCart(e) {
      if (
        parseInt(this.qtyValue) >
        parseInt(this.state.system.settings.cart.product_max_qty)
      ) {
        this.QtyErrMessage = true;
        console.log("higher than allowed qty");
      } else {
        if (!this.toCart) {
          e.preventDefault();
          return this.$emit("update-qty", {
            updatedQty: parseFloat(this.qtyValue).toFixed(2),
            data: this.data,
          });
        }
        this.$loading = true;
        let productData = {
          barcode: this.data.barcode,
          scan: "TRUE",
          unit_mrp: this.data.hasOwnProperty("mrp")
            ? this.data.mrp
            : this.data.unit_mrp,
          url: "product-details",
          qty: parseFloat(this.qtyValue).toFixed(2),
          batch_id: this.data.hasOwnProperty("batch_id")
            ? this.data.batch_id
            : 0,
          serial_id: this.data.hasOwnProperty("serial_id")
            ? this.data.serial_id
            : 0,
          change_mrp: this.data.hasOwnProperty("change_mrp")
            ? this.data.change_mrp
            : "",
          cust_gstin: this.state.billing.billing.customer.data.hasOwnProperty(
            "gstin"
          )
            ? this.state.billing.billing.customer.data.gstin
            : "",
        };
        let data = Object.assign(productData, this.customerData);
        // console.log(pdata);
        this.$store
          .dispatch("billing/addToCart", data)
          .then((res) => {
            if (!this.state.system.isOffline && res.data.status == "fail") {
              let alertData = {
                message: res.data.message,
                type: "danger",
              };
              this.$showAlert = true;
              this.$store.commit("notifications/showAlert", alertData);
              this.$loading = false;
            } else {
              this.$store
                .dispatch("billing/cartDetails")
                .then(() => (this.$loading = false));
            }
            if (typeof Android !== "undefined" && Android !== null) {
              let postData = { type: "weight_submited", data: "" };
              returnValue(postData);
              // } else {
            }
          })
          .catch((err) => {
            this.$loading = false;
            if (err.hasOwnProperty("status")) {
              if (err.status == "customer_not_tag") {
              }
            } else {
              if (err.response.data.status == "product_not_found") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;

                this.$store.commit("notifications/showAlert", alertData);
              }
              if (err.response.data.status == "fail") {
                let alertData = {
                  message: err.response.data.message,
                  type: "danger",
                };
                this.$showAlert = true;

                this.$store.commit("notifications/showAlert", alertData);
              }
            }
          });
        // }
        this.$refs["product-qty-box"].hide();
      }
    },
    updateProductModalBoxClose() {
      qz.serial.closePort(this.state.system.weightPort);
      this.qtyValue = "";
      this.QtyErrMessage = false;
      this.$emit("close-modal", false);
    },
    enableInput() {
      this.inputEnabled = false;
    },
    disableInput() {
      this.inputEnabled = true;
    },
    clearErrMessage(event) {
      // console.log(event);
      if (event.keyCode == 8 || event.keyCode == 46) {
        this.QtyErrMessage = false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.modal-body label {
  padding-left: 0px;
  color: #808080;
  font-size: 13px;
}
.modal-body span {
  color: #c0c0c0;
  font-size: 14px;
}
.theme-light .modal-body label {
  padding-left: 0px;
  color: #c0c0c0;
  font-size: 13px;
}
.theme-light .modal-body span {
  color: #808080;
  font-size: 14px;
}
.modal-body .input-group-text {
  background: #404040;
  border: none;
  color: #fff;
  font-size: 12px;
  font-weight: 400;
  padding: 0;
}
.theme-light .modal-body .input-group-text {
  background: #e0e0e0;
  color: #404040;
}
.theme-dark .input-group-append {
  background: #404040;
}
.theme-dark .modal-body .input-group-text {
  background: #404040;
}
.modal-body input::placeholder {
  color: #606060;
}
.grey-btn {
  padding: 0.5rem 1.5rem !important;
}
.input-group-append {
  background: #e0e0e0;
  padding: 0px 12px;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  // padding-left: 0px;
}
.text-transparent {
  color: transparent !important;
}
</style>
